import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`

	@font-face {
    font-family: Gotham;
    src: url('/fonts/gotham-rounded.otf') format('opentype'),
         url('/fonts/gothamMedium.ttf') format('truetype');
  }

  @font-face {
    font-family: GothamLight;
    src: url('/fonts/gothamLight.otf') format('opentype'),
         url('/fonts/gothamLight.ttf') format('truetype');
  }

	html {
		min-width: 370px;
	}

	body {
		font-family: Gotham !important;
		font-weight: light;
		line-height: 1.7em;
	}

	h1 {
		color: #0798ff;
		font-weight: bold;
		font-size: 3em;
    line-height: 1;
    margin-bottom: 0px;
		@media(max-width: 920px) {
			font-size: 1.5em;
		}
	}

	h2 {
		color: #575757;
		font-weight: 200;
    font-size: 2em;
    line-height: 1.1;
    margin-top: 10px;
		@media(max-width: 920px) {
			font-size: 1.3em;
		}
	}

	h3 {
		color: #e30986;
		line-height: 1.5;
	}

	h4 {
		color: #0798ff;
		line-height: 1.1;
	}

	a {
		color: #119cff;
		&:visited {
			color: #119cff;
		}
	}

	.grey {
		color: #575757;
	}

	@media(max-width: 640px) {
		.small-screen {
			display: block;
			margin: 0em;
		}
		.large-screen {
			display: none;
		}
	}
	@media(min-width: 641px) {
		.small-screen {
			display: none;
		}
		.large-screen {
			display: block;
		}
	}
`;



// WEBPACK FOOTER //
// ./src/global-styles.js